import dayjs from "dayjs"
import { checkTargetGroupsValidity } from "@/helpers"

const validationRules = component => {
    component.formErrors = []
    let query = component.$store.getters.getProgramsQuery
    let startDate = query.start_date
    let endDate = query.end_date
    let daysBetweenDates = dayjs(endDate).diff(startDate, "day") + 1
    let yearsBetweenDates = dayjs(endDate)
        .subtract(1, "d")
        .diff(startDate, "y")
    if (yearsBetweenDates >= 1) {
        component.formErrors.push("Maximum period is 1 year.")
    }
    let storedTargets = query.target_group
    if (daysBetweenDates > 7) {
        let titleLength = 0
        let numberOfGenres = query.genres.genres.length
        if (query.title) titleLength = query.title.length
        let channelCount = query.provider_keys.length
        let countDays = countCertainDays(query.weekdays, new Date(startDate), new Date(endDate))
        if (titleLength < 2 && (numberOfGenres == 0 || numberOfGenres > 5) && (channelCount == 0 || channelCount > 10) && countDays > 7) {
            component.formErrors.push(
                "The selected number of weekdays within the period exceeds 7 days. Please specify either a title with at least two characters, use 1-5 genres or specify 1-10 channels to limit your search."
            )
        }
        let maxTargetGroupCount = 6
        if (Number.isInteger(component.config_NumberOfTargetGroupsProgram)) maxTargetGroupCount = component.config_NumberOfTargetGroupsProgram
        else maxTargetGroupCount = 6
        if (storedTargets.length > maxTargetGroupCount) component.formErrors.push(`Maximum ${maxTargetGroupCount} measures can be used.`)
        if (component.formErrors.length > 0) component.formErrors.unshift("Your search risks returning a very large dataset.")
    }

    // check if the target groups are valid for the chosen period
    // if not, add an error message
    let targetGroupErrors = checkTargetGroupsValidity(storedTargets, startDate)
    if (targetGroupErrors.length > 0) {
        for (let i = 0; i < targetGroupErrors.length; i++) {
            component.formErrors.push(targetGroupErrors[i])
        }
    }

}
function countCertainDays(days, d0, d1) {
    if (!days) return 0
    if (days.indexOf(7) !== -1) {
        days = days.filter(item => item !== 7)
        days.push(0)
    }
    var ndays = 1 + Math.round((d1 - d0) / (24 * 3600 * 1000))
    var sum = function (a, b) {
        return a + Math.floor((ndays + ((d0.getDay() + 6 - b) % 7)) / 7)
    }
    return days.reduce(sum, 0)
}

export { validationRules }
